import { Component } from '@angular/core';

import { SurveyEditorService } from '../../../../services/survey-editor.service';

@Component({
  selector: 'empathy-single-choice-settings',
  templateUrl: 'single-choice-settings.component.html',
  styleUrls: ['./single-choice-settings.component.scss', './_single-choice-settings-theme.component.scss']
})
export class SingleChoiceSettingsComponent {
  constructor(public surveyEditorService: SurveyEditorService) {}
}
